import React, { useState } from 'react';

// Componente de Modal genérico para editar/crear registros
const EditModal = ({ record, onClose, onSave, type }) => {
    const isCreating = !record;
    const [formData, setFormData] = useState(() => {
        if (isCreating) return { cedula: '', nombre: '', correo: '', telefonoOficina: '', telefonoCelular: '' };
        // Si estamos editando, usamos el `telefono` existente como `telefonoOficina`.
        return { ...record, telefonoOficina: record.telefonoOficina || record.telefono || '', telefonoCelular: record.telefonoCelular || '' };
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'telefonoOficina' || name === 'telefonoCelular') {
            const digitsOnly = value.replace(/\D/g, '');
            let formatted = digitsOnly;

            if (digitsOnly.length > 4) {
                // Inserta un guion después del cuarto dígito
                formatted = `${digitsOnly.substring(0, 4)}-${digitsOnly.substring(4, 8)}`;
            }
            setFormData(prev => ({ ...prev, [name]: formatted }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content user-modal" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{isCreating ? 'Crear' : 'Editar'} {type}</h2>
                    <button onClick={onClose} className="modal-close">×</button>
                </div>
                <form onSubmit={handleSubmit} className="modal-body">
                    <div className="form-group">
                        <label htmlFor="cedula">Cédula</label>
                        <input type="text" id="cedula" name="cedula" value={formData.cedula} onChange={handleChange} required disabled={!isCreating} />
                    </div>
                    <div className="form-group">
                        <label htmlFor="nombre">Nombre</label>
                        <input type="text" id="nombre" name="nombre" value={formData.nombre} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="correo">Correo Electrónico</label>
                        <input type="email" id="correo" name="correo" value={formData.correo || ''} onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <div style={{ display: 'flex', gap: '1rem' }}>
                            <div style={{ flex: 1 }}>
                                <label htmlFor="telefonoOficina">Teléfono oficina</label>
                                <input type="tel" id="telefonoOficina" name="telefonoOficina" value={formData.telefonoOficina || ''} onChange={handleChange} placeholder="9999-8888" maxLength="9" />
                            </div>
                            <div style={{ flex: 1 }}>
                                <label htmlFor="telefonoCelular">Teléfono celular</label>
                                <input type="tel" id="telefonoCelular" name="telefonoCelular" value={formData.telefonoCelular || ''} onChange={handleChange} placeholder="9999-8888" maxLength="9" />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                        <button type="submit" className="btn btn-primary">Guardar Cambios</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditModal;